import axios from "axios";
import { API_END_POINT } from "../../../constants/api";
export function addInvoice(invoiceData) {
  let { dispatchId } = invoiceData;
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(invoiceData);
  let response = axios.post(
    `${API_END_POINT}/contract/invoice/add/${dispatchId}`,
    body,
    config
  );

  return response;
}

export function getInvoiceWithDispatchId(id) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/invoice/get/${id}`,
    config
  );
  return response;
}

export function getInvoiceWithContractId(params) {
  let authToken = localStorage.getItem("usertoken");

  let { contractId, limit } = params;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/invoice/get/${contractId}/limit=${
      limit && limit
    }`,
    config
  );
  return response;
}

export function getInvoiceWithCompanyId(params) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = params;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/invoice/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );
  return response;
}

export function getInvoiceById(invoiceId) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.get(
    `${API_END_POINT}/contract/invoice/detail/${invoiceId}`,
    config
  );
}

export function updateInvoice(invoiceId, invoiceData) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.put(
    `${API_END_POINT}/contract/invoice/update/${invoiceId}`,
    JSON.stringify(invoiceData),
    config
  );
}

export function deleteInvoice(invoiceId, companyId) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.delete(
    `${API_END_POINT}/contract/invoice/delete/${invoiceId}/${companyId}`,
    config
  );
}
//   let authToken = localStorage.getItem("usertoken");

//   const config = {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${authToken}`,
//     },
//   };
//   let response = axios.get(
//     `${API_END_POINT}/company/buyer/get-buyer/${buyerId}`,
//     config
//   );
//   return response;
// }

// export function deleteBuyer(buyerIdtoDelete) {
//   let authToken = localStorage.getItem("usertoken");

//   const config = {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${authToken}`,
//     },
//   };
//   let response = axios.delete(
//     `${API_END_POINT}/company/buyer/delete/${buyerIdtoDelete}`,
//     config
//   );
//   return response;
// }

// export function updateBuyer(BuyerIdtoEdit, updatedData) {
//   let authToken = localStorage.getItem("usertoken");

//   const config = {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${authToken}`,
//     },
//   };
//   const body = JSON.stringify(updatedData);
//   let response = axios.put(
//     `${API_END_POINT}/company/buyer/edit/${BuyerIdtoEdit}`,
//     body,
//     config
//   );
//   return response;
// }
